export {
  HoverColor,
  IconBackdrop,
  IconColor,
  IconComponent,
  IconSize,
} from './icon.component';
export { IconModule } from './icon.module';
